export const ro = {
  common: {
    loading: 'Se încarcă...',
    save: 'Salvează',
    cancel: 'Anulează',
    delete: 'Șterge',
    edit: 'Modifică',
    back: 'Înapoi',
    home: 'Acasă',
    navigation: 'Navigare',
    close: 'Închide',
    confirm: 'Confirmă',
    search: 'Caută',
    all: 'Toate',
    yes: 'Da',
    no: 'Nu',
    optional: 'Opțional',
    mandatory: 'Obligatoriu',
    defaultApiError: 'Ei bine, asta e ciudat, ceva nu a mers bine.',
    noResults: 'Nu s-au găsit rezultate',
    error: 'A apărut o eroare',
  },
  upload: {
    invalidType: 'Alege imagini JPG, PNG, WEBP, HEIC, HEIF sau DNG valide.',
    tooLarge: 'Imaginea originală poate avea maximum 30 MB.',
    tooMany: 'Poți încărca maximum 10 imagini pentru un anunț.',
    quotaExceeded: 'Ai atins limita de stocare pentru imagini. Șterge imagini nefolosite și încearcă din nou.',
    invalidData: 'Imaginea nu a putut fi validată. Verifică formatul și încearcă din nou.',
    processingFailed: 'Imaginea nu a putut fi procesată. Alege o altă imagine și încearcă din nou.',
  },
  productCarousel: {
    viewAll: 'Vezi toate',
    previous: 'Anunțurile anterioare',
    next: 'Următoarele anunțuri',
    loading: 'Se încarcă anunțurile...',
    emptyTitle: 'Momentan nu sunt anunțuri',
  },
  header: {
    logo: 'Logo',
    addListing: 'Adaugă un anunț',
    login: 'Autentificare',
    myAccount: 'Contul meu',
  },
  accountTooltip: {
    description: 'Intră în contul tău roade.ro să cumperi și să vinzi alimente autentice românești!',
    loginButton: 'Intră în cont',
    noAccountButton: 'Nu ai cont?',
  },
  accountDropdown: {
    profile: 'Profil',
    favorites: 'Favorite',
    orders: 'Comenzi',
    orderStatistics: 'Statistici',
    orderReport: 'Raport',
    locations: 'Locații',
    messages: 'Mesaje',
    announcements: 'Anunțuri',
    administration: 'Administrare',
    help: 'Ajutor',
    settings: 'Setări',
    logout: 'Logout',
  },
  login: {
    title: 'Bine te-am regăsit!',
    email: 'Email',
    password: 'Parolă',
    forgotPassword: 'Ai uitat parola?',
    submitButton: 'Intră în cont',
    noAccount: 'Nu ai un cont încă?',
    createAccount: 'Creează-ți unul',
    showPassword: 'Arată parola',
    hidePassword: 'Ascunde parola',
    loginError: 'Autentificare eșuată. Verifică emailul și parola.',
    rateLimited: 'Prea multe încercări de autentificare. Încearcă din nou mai târziu.',
    loginSuccess: 'Te-ai autentificat cu succes!',
    emailNotVerified: 'Adresa de email nu a fost confirmată. Verifică mesajul primit după înregistrare.',
    resendVerification: 'Retrimite emailul de confirmare',
    resendingVerification: 'Se retrimite...',
    verificationResent: 'Cererea a fost procesată. Verifică din nou căsuța de email.',
    verificationResendError: 'Nu am putut retrimite emailul. Încearcă din nou.',
  },
  googleSignIn: {
    separator: 'sau',
    continueWithGoogle: 'Continuă cu Google',
    signUpWithGoogle: 'Înregistrează-te cu Google',
    signingIn: 'Se autentifică...',
    signingUp: 'Se creează contul...',
    error: 'Autentificarea cu Google nu a reușit. Încearcă din nou.',
    rateLimited: 'Prea multe încercări de autentificare. Încearcă din nou mai târziu.',
    emailNotVerified: 'Google nu a confirmat adresa de email a acestui cont.',
    identityConflict: 'Acest cont roade.ro este deja asociat cu un alt cont Google. Autentifică-te folosind metoda inițială.',
    accountLinkRequired: 'Există deja un cont roade.ro cu această adresă. Autentifică-te mai întâi cu email și parolă.',
    accountBlocked: 'Acest cont este blocat. Contactează-ne la contact@roade.ro.',
    passwordLoginUnavailable: 'Acest cont se autentifică cu Google. Folosește butonul „Continuă cu Google” sau setează o parolă din „Ai uitat parola?”.',
    termsUpdated: 'Termenii și Condițiile au fost actualizați. Te rugăm să îi accepți din nou.',
    termsLoadError: 'Nu am putut încărca Termenii și Condițiile. Încearcă din nou.',
    consentTitle: 'Încă un pas',
    consentDescription: 'Pentru a-ți crea contul roade.ro avem nevoie de acordul tău privind Termenii și Condițiile.',
    consentRequired: 'Trebuie să accepți Termenii și Condițiile pentru a continua.',
    consentConfirm: 'Creează contul',
    consentSubmitting: 'Se creează contul...',
  },
  forgotPassword: {
    title: 'Ai uitat parola?',
    description: 'Introdu adresa ta de email și îți vom trimite un link pentru a-ți reseta parola.',
    emailLabel: 'Email',
    emailPlaceholder: 'maria@roade.ro',
    emailRequired: 'Te rugăm să introduci adresa de email.',
    submitButton: 'Trimite',
    submitting: 'Se trimite...',
    closeButton: 'Închide',
    successMessage: 'Dacă există un cont pentru această adresă, vei primi un link de resetare a parolei.',
    rateLimited: 'Ai solicitat prea multe linkuri de resetare. Încearcă din nou mai târziu.',
    errorMessage: 'A apărut o eroare. Te rugăm să încerci din nou.',
  },
  resetPassword: {
    title: 'Resetează parola',
    description: 'Introdu noua ta parolă mai jos.',
    newPassword: 'Parolă nouă',
    confirmPassword: 'Confirmă parola',
    passwordPlaceholder: 'Folosește între 8 și 50 de caractere și cel puțin o literă',
    passwordValidation: 'Parola trebuie să aibă între 8 și 50 de caractere și cel puțin o literă.',
    confirmPasswordPlaceholder: 'Reintroduceți parola',
    submitButton: 'Resetează parola',
    showPassword: 'Arată parola',
    hidePassword: 'Ascunde parola',
    passwordMismatch: 'Parolele nu coincid.',
    resetError: 'A apărut o eroare la resetarea parolei. Te rugăm să încerci din nou.',
    resetSuccess: 'Parola a fost resetată cu succes!',
  },
  register: {
    title: 'Încântați de cunoștință!',
    lastName: 'Nume',
    lastNamePlaceholder: 'Popescu',
    firstName: 'Prenume',
    firstNamePlaceholder: 'Maria',
    email: 'Email',
    emailPlaceholder: 'maria@roade.ro',
    password: 'Parolă',
    passwordPlaceholder: 'Folosește între 8 și 50 de caractere și cel puțin o literă',
    passwordValidation: 'Parola trebuie să aibă între 8 și 50 de caractere și cel puțin o literă.',
    termsAndConditions: 'Am cel puțin 18 ani, am citit și sunt de acord cu',
    termsLink: 'Termenii și Condițiile',
    termsText: 'ale roade.ro.',
    privacyNotice: 'Prelucrăm datele tale potrivit',
    privacyNoticeLink: 'Politicii de Confidențialitate',
    marketingEmails: 'Doresc să primesc oferte și noutăți prin email',
    submitButton: 'Înregistrează-te',
    haveAccount: 'Ai un cont deja?',
    loginButton: 'Intră în cont',
    showPassword: 'Arată parola',
    hidePassword: 'Ascunde parola',
    registrationError: 'Înregistrarea a eșuat. Te rugăm să încerci din nou.',
    registrationSuccess: 'Cont creat cu succes!',
    invalidEmail: 'Adresa de email nu este validă. Te rugăm să folosești o adresă de email corectă.',
    duplicateEmail: 'Există deja un cont pentru această adresă de email. Autentifică-te cu Google sau folosește „Ai uitat parola?” pentru a seta o parolă.',
    termsUnavailable: 'Nu am putut încărca versiunea curentă a Termenilor și Condițiilor. Te rugăm să încerci din nou.',
    termsUpdated: 'Termenii și Condițiile au fost actualizați. Te rugăm să îi citești și să îi accepți din nou.',
    retry: 'Reîncearcă',
    verifyEmailTitle: 'Confirmă adresa de email',
    verifyEmailDescription: 'Am trimis un link de confirmare la {email}.',
    verifyEmailHint: 'Deschide mesajul și apasă pe link pentru a activa contul. Verifică și folderul Spam.',
    resendVerification: 'Retrimite emailul de confirmare',
    resendingVerification: 'Se retrimite...',
    verificationResent: 'Cererea a fost procesată. Verifică din nou căsuța de email.',
    verificationResendError: 'Nu am putut retrimite emailul. Încearcă din nou.',
  },
  emailVerification: {
    verifyingTitle: 'Confirmăm adresa de email',
    verifyingDescription: 'Te rugăm să aștepți câteva momente.',
    successTitle: 'Adresa de email a fost confirmată',
    successDescription: 'Contul tău este activ. Acum te poți autentifica.',
    errorTitle: 'Confirmarea nu a reușit',
    expiredDescription: 'Linkul de confirmare a expirat. Solicită un link nou din pagina de autentificare.',
    invalidDescription: 'Linkul de confirmare nu este valid sau a fost deja folosit.',
    errorDescription: 'A apărut o eroare. Te rugăm să încerci din nou.',
    loginButton: 'Intră în cont',
  },
  home: {
    heroEyebrow: 'DIRECT DE LA PRODUCĂTORI',
    heroTitle: 'Găsește gustul de acasă.',
    heroDescription: 'Produse locale, oameni reali și povești care merită descoperite.',
    searchTabBuy: 'Ce se caută',
    searchTabSell: 'Ce se vinde',
    searchTabBuyTooltip: 'Anunțuri de cerere create de cumpărători care au căutat produsele și nu le-au găsit. Vânzătorii pot contacta cumpărătorii dacă au produsele disponibile.',
    searchTabSellTooltip: 'Anunțuri de vânzare cu produse disponibile de la producători și vânzători locali. Poți contacta vânzătorii direct pentru a discuta detalii.',
    searchPlaceholder: 'Caută după titlul anunțului',
    locationPlaceholder: 'Toată țara',
    searchButton: 'Caută',
    categoriesTitle: 'Categorii',
    loadingCategories: 'Se încarcă categoriile...',
    categoriesCarousel: 'Categorii de anunțuri',
    previousCategories: 'Categoriile anterioare',
    nextCategories: 'Categoriile următoare',
    categoryPage: 'Pagina {page} din {total}',
    subcategoriesLabel: 'Subcategorii',
    viewAllCategory: 'Vezi toate anunțurile',
    announcementsTitle: 'Anunțuri noi',
    loadingAnnouncements: 'Se încarcă anunțurile...',
    aboutTitle: 'Despre noi',
    aboutPlatformTitle: 'Despre platformă',
    aboutPlatformText: 'Platforma are ca scop sprijinirea producătorilor locali, oferindu-le un spațiu unde își pot promova și vinde produsele direct către alți utilizatori interesați. Platforma nu intermediază vânzarea, nu procesează plăți și nu oferă servicii de livrare. Rolul acesteia este exclusiv de a facilita comunicarea dintre utilizatori. Cumpărătorii și vânzătorii:\n• comunică direct între ei;\n• stabilesc de comun acord detaliile tranzacției (preț, plată, livrare);\n• își asumă responsabilitatea pentru acordul încheiat.',
    aboutSellTitle: 'Ce se vinde',
    aboutSellText: 'Aici găsești produsele oferite de producători și alți vânzători. Poți căuta produse și contacta vânzătorii direct pentru detalii. Dacă ai produse de vânzare, publică un anunț alegând „Vreau să vând”.',
    aboutBuyTitle: 'Ce se caută',
    aboutBuyText: 'Aici găsești cererile utilizatorilor care vor să cumpere anumite produse. Dacă ai produsele căutate, îi poți contacta direct. Pentru a publica propria cerere de cumpărare, alege „Vreau să cumpăr”.',
    aboutOperatorTitle: 'Cine operează platforma',
    aboutOperatorText: 'roade.ro este operată de EMARKET DIGITAL VENTURES S.R.L., cu sediul în Str. Avram Iancu nr. 8, et. 1, ap. 2B, loc. Cluj Napoca, județul Cluj.\nCod Unic de Înregistrare (CUI): 55676396\nNumăr de ordine în registrul comerțului: J2026057030009\nE-mail: contact@roade.ro\nTelefon: 0774 547 296',
    readMoreAboutLink: 'Mai multe informații puteți găsi în secțiunea despre noi',
    addAnnouncementButton: 'Adaugă un anunț',
    searchCounty: 'Caută județ...',
    searchLocation: 'Caută localitate...',
  },
  searchResults: {
    resultsEyebrow: 'Piața locală',
    resultsSubtitle: 'Compară ofertele producătorilor și găsește alegerea potrivită pentru tine.',
    tabBuy: 'Ce se caută',
    tabSell: 'Ce se vinde',
    resultsFound: '{count} de anunțuri găsite',
    resultFoundSingular: '{count} anunț găsit',
    resultsFoundPlural: '{count} anunțuri găsite',
    orderBy: 'Ordonează după',
    rankingExplanationLink: 'Cum sunt ordonate rezultatele?',
    newest: 'Cele mai noi',
    oldest: 'Cele mai vechi',
    priceAscending: 'Preț crescător',
    priceDescending: 'Preț descrescător',
    viewType: 'Tip afișare',
    listView: 'Afișare listă',
    gridView: 'Afișare grilă',
    searchButton: 'Caută',
    distance: 'Distanța',
    allCategories: 'Toate Categoriile',
    allSubcategories: 'Toate subcategoriile',
    allCountry: 'Toată țara',
    filterCategory: 'Categorie',
    filterSubcategory: 'Subcategorie',
    filterPriceRange: 'Interval preț (lei)',
    filterPriceMin: 'Min',
    filterPriceMax: 'Max',
    filterNegotiable: 'Negociabil',
    filterSeller: 'Vânzător',
    sellerPlaceholder: 'Nume vânzător',
    loading: 'Se încarcă...',
    noResults: 'Nu am găsit rezultate',
    emptyTitle: 'Nu am găsit anunțuri',
    emptyDescription: 'Încearcă să modifici căutarea sau să elimini o parte dintre filtre.',
    homeAction: 'Înapoi la pagina principală',
    searchCounty: 'Caută județ...',
    searchLocation: 'Caută localitate...',
    filters: 'Filtre',
    activeFilters: 'Filtre active: {count}',
    resetFilters: 'Resetează',
    applyFilters: 'Aplică filtrele',
  },
  notFound: {
    code: 'Eroare 404',
    title: 'Pagina nu a fost găsită',
    description: 'Adresa accesată nu există sau pagina a fost mutată.',
    homeAction: 'Pagina principală',
    searchAction: 'Vezi anunțurile',
  },
  accountType: {
    eyebrow: 'Tipul contului',
    title: 'Cum folosești roade.ro?',
    description: 'Înainte să publici primul anunț, alege tipul de cont care reflectă modul în care vinzi pe roade.ro. Informația va fi afișată cumpărătorilor pentru mai multă transparență.',
    privateLabel: 'Vânzător privat',
    privateDescription: 'Persoană fizică ce vinde în afara unei activități comerciale ori profesionale, de exemplu ocazional surplusul din gospodărie. Vânzarea produselor proprii nu înseamnă automat vânzare privată.',
    companyLabel: 'Vânzător profesionist',
    companyDescription: 'Persoană fizică sau juridică ce vinde în cadrul activității sale comerciale, de producție, artizanale ori profesionale, inclusiv fermieri, PFA-uri și societăți. Și activitatea sezonieră poate fi profesională.',
    note: 'Nu ești sigur ce tip de cont ți se potrivește? Îl poți schimba ulterior din Contul meu > Setări. Statutul depinde de activitatea reală, nu doar de forma juridică, numărul de anunțuri sau opțiunea selectată. Alegerea statutului privat nu înlătură obligațiile unui profesionist. Actualizează declarația când activitatea se schimbă; un statut incorect poate fi raportat.',
    companyDetailsDescription: 'Completează datele profesionale care vor fi afișate cumpărătorilor. Poți prelua datele publice din registrul ANAF și apoi să le verifici sau să le corectezi.',
    taxId: 'CUI / CIF',
    taxIdPlaceholder: 'Ex. RO14399840',
    companyLookup: 'Preia din ANAF',
    companyLookingUp: 'Se verifică...',
    companyLookupHint: 'ANAF nu furnizează întotdeauna telefonul și nu furnizează emailul. Completează manual câmpurile lipsă.',
    companyLookupSuccess: 'Datele publice disponibile au fost preluate din ANAF. Verifică-le înainte de salvare.',
    companyLookupError: 'Nu am putut prelua datele. Verifică CUI/CIF sau completează câmpurile manual.',
    companyInactive: 'ANAF indică faptul că entitatea este inactivă fiscal. Verifică situația înainte de a continua.',
    legalName: 'Denumire legală',
    legalForm: 'Formă juridică',
    tradeRegisterNumber: 'Număr Registrul Comerțului',
    tradeRegisterNumberOptional: 'Număr Registrul Comerțului (dacă există)',
    registeredOffice: 'Sediu social',
    companyEmail: 'Email profesional',
    companyPhone: 'Telefon profesional',
    vatRegistered: 'Înregistrat în scopuri de TVA',
    yes: 'Da',
    no: 'Nu',
    privateDeclaration: 'Declar pe propria răspundere că folosesc contul în calitate de persoană fizică, în afara unei activități comerciale sau profesionale.',
    companyDeclaration: 'Declar că acționez în scopuri comerciale sau profesionale și confirm că datele furnizate sunt complete, corecte și actuale.',
    requiredFields: 'Completează câmpurile marcate și confirmă declarația.',
    continue: 'Salvează și continuă',
    saving: 'Se salvează...',
    cancel: 'Mai târziu',
    saveError: 'Nu am putut salva tipul contului. Încearcă din nou.',
    infoLabel: 'Informații despre tipul contului',
    privatePublicLabel: 'Vânzător privat',
    privatePublicDescription: 'Acest utilizator a declarat că vinde în afara unei activități comerciale ori profesionale, de exemplu prin vânzări ocazionale de produse proprii sau surplus din gospodărie. Statutul este declarat de utilizator, nu certificat de roade.ro, și trebuie să corespundă activității reale.',
    companyPublicLabel: 'Vânzător profesionist',
    companyPublicDescription: 'Acest utilizator a declarat că vinde în cadrul activității sale comerciale, de producție, artizanale ori profesionale. Un profesionist poate fi persoană fizică sau juridică, inclusiv fermier, PFA ori societate, iar activitatea poate fi sezonieră. Statutul și datele sunt declarate de utilizator, nu certificate de roade.ro.',
    accountDetailsCompanyTitle: 'Datele profesionistului',
    accountDetailsPrivateTitle: 'Informații despre cont',
    consumerRightsTitle: 'Drepturile consumatorilor',
    consumerRightsCompanySummary: 'Protecția aplicabilă atunci când cumperi de la un profesionist',
    consumerRightsPrivateSummary: 'Ce trebuie să știi când cumperi de la un vânzător privat',
    consumerRightsCompanyIntro: 'Când cumperi în calitate de consumator de la un vânzător care acționează în scop profesional, se aplică drepturile prevăzute de legislația privind protecția consumatorilor, în condițiile legii.',
    consumerRightsCompanyWithdrawal: 'Pentru contractele la distanță poate exista un drept de retragere de 14 zile. Acesta are excepții importante pentru produsele comercializate pe roade.ro, inclusiv bunurile care se deteriorează sau expiră rapid și, în anumite situații, bunurile sigilate desigilate din motive de igienă.',
    consumerRightsPrivateIntro: 'Când vânzătorul acționează efectiv în afara unei activități profesionale, drepturile speciale precum retragerea în 14 zile și garanția legală de conformitate din OUG nr. 140/2021 nu se aplică vânzării. Rămân aplicabile înțelegerea dintre părți și normele generale de drept civil. Dacă activitatea reală este profesională, eticheta de vânzător privat nu înlătură drepturile legale ale consumatorului.',
    consumerResponsibilitiesTitle: 'Cine este responsabil',
    platformResponsibility: 'roade.ro facilitează publicarea anunțurilor și contactul dintre utilizatori. roade.ro nu este parte la tranzacție și nu procesează plata, nu organizează livrarea și nu oferă un program de protecție a achiziției.',
    companySellerResponsibility: 'Vânzătorul profesionist este responsabil pentru corectitudinea anunțului, legalitatea, siguranța și conformitatea produselor, informațiile oferite înainte de cumpărare, documentele fiscale, livrarea și respectarea drepturilor consumatorului atunci când acestea sunt aplicabile.',
    privateSellerResponsibility: 'Vânzătorul privat este responsabil să descrie corect produsul și să respecte condițiile convenite direct cu cumpărătorul.',
    buyerResponsibility: 'Cumpărătorul trebuie să verifice informațiile despre produs și vânzător și să stabilească direct condițiile de plată, predare sau livrare.',
    companyConsumerAction: 'Pentru retururi, garanții, neconformități sau alte drepturi, contactează mai întâi vânzătorul profesionist. Dacă problema nu se rezolvă, poți solicita sprijinul autorităților competente, inclusiv ANPC, atunci când este aplicabil.',
    privateConsumerAction: 'Dacă apare o problemă, contactează direct vânzătorul. roade.ro nu poate decide litigiul și nu rambursează plățile efectuate între utilizatori.',
    consumerRightsDisclaimer: 'Aceste informații au caracter general și nu înlocuiesc consultanța juridică.',
    declaredAt: 'Declarație actualizată',
    vatPayer: 'Plătitor de TVA',
    nonVatPayer: 'Neplătitor de TVA',
  },
  productDetail: {
    loading: 'Se încarcă produsul...',
    notFound: 'Produsul nu a fost găsit',
    notFoundDescription: 'Anunțul nu mai este disponibil sau adresa accesată nu este corectă.',
    notFoundAction: 'Înapoi la pagina principală',
    listingType: 'Tip anunț',
    wantToSell: 'Ce se vinde',
    wantToBuy: 'Ce se caută',
    share: 'Distribuie',
    shareLinkCopied: 'Linkul anunțului a fost copiat.',
    shareError: 'Nu am putut distribui anunțul. Încearcă din nou.',
    negotiable: 'Negociabil',
    nonNegotiable: 'Nenegociabil',
    leaveRating: 'Lasă un rating pentru produs',
    descriptionTitle: 'Descriere',
    report: 'Raportează',
    showPhone: 'Arată',
    hidePhone: 'Ascunde',
    phoneUnavailable: 'Număr indisponibil',
    sendMessage: 'Lasă un mesaj privat',
    messagePlaceholder: 'Salut! Doresc să cumpăr...',
    location: 'Unde se află',
    rateSellerLabel: 'Lasă un rating pentru vânzător',
    moreFromSeller: 'Mai multe anunțuri de la acest vânzător',
    moreFromSellerEmptyTitle: 'Nu există alte anunțuri de la acest vânzător',
    moreFromSellerEmptyDescription: 'Descoperă produse similare publicate de alți vânzători.',
    moreFromSellerEmptyAction: 'Descoperă anunțuri de la alți vânzători',
    postedToday: 'Publicat azi la {time}',
    postedOn: 'Publicat {date} la {time}',
    oneView: '1 vizualizare',
    views: '{count} vizualizări',
    messageSent: 'Mesaj trimis cu succes!',
    noImage: 'Fără imagine',
    ratingConfirmTitle: 'Confirmare Rating',
    ratingConfirmProduct: 'Dorești să acorzi rating-ul de {rating} stele pentru acest produs?',
    ratingConfirmSeller: 'Dorești să acorzi rating-ul de {rating} stele pentru acest vânzător?',
    ratingSuccess: 'Rating-ul a fost înregistrat cu succes!',
    ratingError: 'A apărut o eroare la salvarea rating-ului. Încearcă din nou.',
    productSelfRatingNotAllowed: 'Nu poți evalua propriul anunț.',
    userSelfRatingNotAllowed: 'Nu te poți evalua singur.',
    ratingNotVerified: 'Ratingurile nu sunt verificate ca provenind din achiziții finalizate.',
  },
  reportModal: {
    title: 'Raportează',
    question: 'Ce este în neregulă cu anunțul?',
    spam: 'Spam',
    wrongCategory: 'Categorie incorectă',
    forbiddenProduct: 'Produs interzis',
    expiredProduct: 'Anunț expirat / produs indisponibil',
    fraud: 'Fraudă / tentativă de fraudă',
    other: 'Altele',
    otherPlaceholder: 'Descrie problema...',
    submit: 'Trimite',
    successMessage: 'Raport trimis cu succes!',
    errorMessage: 'A apărut o eroare. Te rugăm să încerci din nou.',
  },
  reportUserModal: {
    title: 'Raportează utilizator',
    question: 'Ce este în neregulă cu acest utilizator?',
    spam: 'Spam / Comportament suspect',
    inappropriateContent: 'Conținut nepotrivit',
    harassment: 'Hărțuire',
    scam: 'Înșelătorie / Fraudă',
    fakeProfile: 'Profil fals',
    sellerStatus: 'Statut privat / companie incorect',
    other: 'Altele',
    otherPlaceholder: 'Descrie problema...',
    submit: 'Trimite',
    successMessage: 'Raport trimis cu succes!',
    errorMessage: 'A apărut o eroare. Te rugăm să încerci din nou.',
  },
  reportChatModal: {
    title: 'Raportează conversația',
    question: 'Ce este în neregulă cu această conversație?',
    spam: 'Spam / mesaje nesolicitate',
    harassment: 'Hărțuire',
    inappropriateContent: 'Conținut nepotrivit',
    scam: 'Înșelătorie / fraudă',
    offensiveLanguage: 'Limbaj ofensator',
    other: 'Altele',
    otherPlaceholder: 'Descrie problema...',
    submit: 'Trimite',
    successMessage: 'Raport trimis cu succes!',
    errorMessage: 'A apărut o eroare. Te rugăm să încerci din nou.',
    reportAction: 'Raportează conversația',
  },
  createProduct: {
    title: 'Adaugă un anunț',
    wantToSell: 'Vreau să vând',
    wantToBuy: 'Vreau să cumpăr',
    imagesTitle: 'Imagini',
    imagesHint: 'Prima imagine va fi imaginea principală a anunțului tău.',
    addMoreImages: 'Adaugă\nmai multe\nimagini',
    detailsTitle: 'Detalii',
    titleLabel: 'Titlu',
    titlePlaceholder: 'ex. Vand Mere Golden',
    locationLabel: 'Localitate',
    locationPlaceholder: 'Toată țara',
    descriptionLabel: 'Descriere',
    descriptionPlaceholder: 'Descrie în cât mai multe detalii produsul tău... \n\n\n',
    priceLabel: 'Preț (LEI)',
    pricePlaceholder: 'ex. 43,50',
    priceUnitLabel: 'Unitate de măsură',
    negotiable: 'Negociabil',
    categoryLabel: 'Categorie',
    categoryPlaceholder: 'ex. Fructe și Legume',
    subcategoryLabel: 'Subcategorie',
    subcategoryPlaceholder: 'ex. Mere',
    subcategoryOptional: '(Opțional)',
    yourLocations: 'Locațiile tale',
    allLocations: 'Toată țara',
    previewButton: 'Previzualizează',
    publishButton: 'Publică Anunțul',
    publishing: 'Se publică...',
    processingImages: 'Se procesează imaginile...',
    publishingOverlay: 'Se publică anunțul...',
    savingOverlayHint: 'Încărcăm imaginile. Poate dura câteva secunde, nu închide pagina.',
    priceUnitSearchPlaceholder: 'Caută unități...',
    priceUnitNoResults: 'Nu s-au găsit unități',
    errorMissingFields: 'Te rugăm să completezi toate câmpurile obligatorii.',
    errorInvalidPrice: 'Prețul trebuie să fie mai mare decât 0, de cel mult 9.999.999 lei și să aibă maximum două zecimale.',
    errorPublishing: 'A apărut o eroare la publicarea anunțului. Te rugăm să încerci din nou.',
    announcementLimitReached: 'Ai atins limita de anunțuri. Contactează-ne prin pagina Contact pentru a solicita o limită mai mare.',
    errorUploadingImages: 'Produsul a fost creat cu succes, dar imaginile nu au putut fi încărcate. Te rugăm să încerci să actualizezi produsul mai târziu.',
    successCreated: 'Produs creat cu succes!',
    verificationPending: 'Anunțul devine activ imediat sau după verificare.',
    priceUnits: {
      perKilogram: 'Kilogram',
      perGram: 'Gram',
      perTonne: 'Tonă',
      perLitre: 'Litru',
      perMillilitre: 'Mililitru',
      perPiece: 'Bucată',
      perBox: 'Cutie',
      perBag: 'Sac',
      perPackage: 'Pachet',
      perDozen: 'Duzină',
      perHundred: 'Sută',
      perMetre: 'Metru',
      perSquareMetre: 'Metru Pătrat',
      perCubicMetre: 'Metru Cub',
      perHectare: 'Hectar',
    },
  },
  editProduct: {
    title: 'Modifică anunțul',
    saveButton: 'Actualizează',
    saving: 'Se actualizează...',
    savingOverlay: 'Se salvează modificările...',
    errorLoading: 'Nu am putut încărca produsul. Vă rugăm încercați din nou.',
    errorSaving: 'A apărut o eroare la actualizarea anunțului. Te rugăm să încerci din nou.',
    successUpdated: 'Produs actualizat cu succes!',
    verificationPending: 'Anunțul modificat devine activ imediat sau după verificare.',
  },
  profile: {
    title: 'Profil',
    eyebrow: 'Spațiul tău',
    subtitle: 'Gestionează informațiile afișate în profilul tău.',
    loadingOverview: 'Se încarcă prezentarea profilului...',
    loadingDetails: 'Se încarcă datele profilului...',
    completionLabel: 'Profil completat',
    personalDetails: 'Date personale',
    personalDetailsDescription: 'Informațiile prin care ceilalți utilizatori te pot recunoaște și contacta.',
    producerDetails: 'Detalii producător',
    producerDetailsDescription: 'Prezintă numele fermei, companiei sau activității tale locale.',
    socialLinks: 'Rețele sociale',
    socialLinksDescription: 'Ajută comunitatea să descopere mai ușor activitatea ta online.',
    security: 'Securitate',
    securityDescription: 'Protejează accesul la cont prin actualizarea periodică a parolei.',
    firstName: 'Prenume',
    lastName: 'Nume',
    email: 'Email',
    phone: 'Număr de telefon',
    phonePlaceholder: '0771 23 32 01',
    invalidPhone: 'Numărul de telefon nu este valid',
    description: 'Despre tine',
    descriptionPlaceholder: 'Spune-le altora puțin despre tine...',
    companyName: 'Nume Firma',
    companyNamePlaceholder: 'Ex. roade.ro',
    saveButton: 'Salvează modificările',
    saving: 'Se salvează...',
    unsavedChanges: 'Ai modificări nesalvate',
    unsavedChangesHint: 'Verifică datele, apoi salvează profilul.',
    savedState: 'Profilul este actualizat',
    savedStateHint: 'Toate modificările tale sunt salvate.',
    changePassword: 'Schimbă Parola',
    changingPassword: 'Se schimbă...',
    currentPassword: 'Parola actuală',
    currentPasswordPlaceholder: 'Introdu parola actuală',
    newPassword: 'Parolă nouă',
    confirmNewPassword: 'Confirmă parola nouă',
    confirmNewPasswordPlaceholder: 'Reintrodu parola nouă',
    passwordMismatch: 'Parolele noi nu coincid.',
    profilePicture: 'Poză de profil',
    addPhoto: 'Adaugă Poză',
    removeImage: 'Șterge imaginea',
    changeImage: 'Schimbă imaginea',
    viewPhoto: 'Vezi fotografia de profil',
    imageProcessing: 'Se pregătește...',
    errorLoading: 'Nu am putut încărca profilul. Vă rugăm încercați din nou.',
    errorSaving: 'Nu am putut salva modificările. Vă rugăm încercați din nou.',
    deleteAccountTitle: 'Șterge contul tău',
    dangerZone: 'Zonă sensibilă',
    deleteAccountTitleCompany: 'roade.ro',
    deleteAccountDescription: 'Ștergerea contului tău este o acțiune ireversibilă prin care datele tale vor dispărea. Ai în vedere că din motive legale, unele date pot fi păstrate.',
    deleteAccountButton: 'Șterge',
    deleteAccountModalTitle: 'Șterge contul?',
    deleteAccountModalMessage: 'Sunteți sigur că doriți să vă ștergeți contul? Această acțiune este ireversibilă.',
    deleteAccountConfirm: 'Șterge contul',
    deleteAccountSuccess: 'Contul a fost șters cu succes',
    deleteAccountError: 'Nu am putut șterge contul. Vă rugăm încercați din nou.',
    facebook: 'Facebook',
    facebookPlaceholder: 'https://facebook.com/username',
    instagram: 'Instagram',
    instagramPlaceholder: 'https://instagram.com/username',
    tiktok: 'TikTok',
    tiktokPlaceholder: 'https://tiktok.com/@username',
    invalidUrl: 'URL invalid',
    invalidFacebookUrl: 'Introdu un URL valid de pe facebook.com.',
    invalidInstagramUrl: 'Introdu un URL valid de pe instagram.com.',
    invalidTiktokUrl: 'Introdu un URL valid de pe tiktok.com.',
  },
  locations: {
    title: 'Locații',
    eyebrow: 'Spațiile tale',
    subtitle: 'Organizează localitățile pentru anunțuri și punctele folosite la livrarea comenzilor.',
    savedOne: '1 locație salvată',
    savedCount: '{count} locații salvate',
    savedLabelOne: 'Locație salvată',
    savedLabel: 'Locații salvate',
    sectionsLabel: 'Tip locații',
    announcementsTab: 'Locații anunțuri',
    ordersTab: 'Locații comenzi',
    announcementLocationsTitle: 'Locații pentru anunțuri',
    announcementLocationsDescription: 'Gestionează localitățile folosite în anunțuri și alege localitatea implicită.',
    createLocationTitle: 'Locație nouă pentru anunțuri',
    closeForm: 'Închide formularul',
    location: 'Localitate',
    primaryLocation: 'Localitatea principală',
    secondaryLocations: 'Locații secundare',
    secondary: 'Secundară',
    addLocation: 'Adaugă locație',
    searchPlaceholder: 'Caută localitatea',
    setDefault: 'Setează ca implicit',
    default: 'Implicit',
    cancel: 'Anulează',
    save: 'Salvează',
    saving: 'Se salvează...',
    noLocations: 'Nu aveți locații salvate.',
    errorLoading: 'Nu am putut încărca locațiile. Vă rugăm încercați din nou.',
    errorDeleting: 'Nu am putut șterge locația. Vă rugăm încercați din nou.',
    errorAdding: 'Nu am putut adăuga locația. Vă rugăm încercați din nou.',
    deleteTitle: 'Șterge locația?',
    deleteMessage: 'Locația va fi eliminată din lista ta. Ești sigur că vrei să continui?',
    deleteConfirm: 'Șterge locația',
    orderLocations: {
      title: 'Puncte de livrare pentru comenzi',
      description: 'Organizează puncte diferite în aceeași localitate, de exemplu Vevo și Iulius Mall.',
      add: 'Adaugă punct',
      editTitle: 'Editează punctul de livrare',
      createTitle: 'Punct de livrare nou',
      closeForm: 'Închide formularul',
      locality: 'Localitate',
      localityPlaceholder: 'Caută localitatea',
      localityAria: 'Localitatea punctului de livrare',
      name: 'Numele punctului',
      namePlaceholder: 'Ex: Iulius Mall',
      address: 'Adresă sau detalii (opțional)',
      addressPlaceholder: 'Ex: intrarea principală, lângă parcare',
      cancel: 'Anulează',
      save: 'Salvează',
      saving: 'Se salvează...',
      loading: 'Se încarcă...',
      savedOne: '1 punct de livrare salvat',
      savedCount: '{count} puncte de livrare salvate',
      savedLabelOne: 'Punct de livrare',
      savedLabel: 'Puncte de livrare',
      empty: 'Nu ai încă puncte de livrare pentru comenzi.',
      active: 'Activ',
      archived: 'Arhivat',
      oneOrder: '1 comandă',
      orderCount: '{count} comenzi',
      edit: 'Editează',
      archive: 'Arhivează',
      delete: 'Șterge',
      restore: 'Reactivează',
      requiredError: 'Selectează localitatea și completează numele punctului.',
      created: 'Punctul de livrare a fost adăugat.',
      updated: 'Punctul de livrare a fost actualizat.',
      saveError: 'Nu am putut salva punctul de livrare.',
      archiveTitle: 'Arhivezi punctul de livrare?',
      deleteTitle: 'Ștergi punctul de livrare?',
      archiveConfirm: 'Punctul este folosit de {count} comenzi. Va fi arhivat și păstrat în istoric. Continui?',
      deleteConfirm: 'Punctul nu este folosit de nicio comandă și va fi șters definitiv. Continui?',
      archivedSuccess: 'Punctul de livrare a fost arhivat.',
      deletedSuccess: 'Punctul de livrare a fost șters.',
      removeError: 'Nu am putut elimina punctul de livrare.',
      restoredSuccess: 'Punctul de livrare a fost reactivat.',
      restoreError: 'Nu am putut reactiva punctul de livrare.',
      loadError: 'Nu am putut încărca punctele de livrare.',
    },
  },
  myAnnouncements: {
    title: 'Anunțurile mele',
    tabSell: 'Vreau să vând',
    tabBuy: 'Vreau să cumpăr',
    workspaceLabel: 'Spațiul tău de administrare',
    subtitle: 'Urmărește performanța, răspunde cumpărătorilor și gestionează toate anunțurile dintr-un singur loc.',
    addAnnouncement: 'Adaugă un anunț',
    filtersTitle: 'Căutare și filtre pentru anunțuri',
    announcementType: 'Tipul anunțului',
    resultsTitle: 'Anunțurile tale',
    oneAnnouncement: '1 anunț',
    announcementCount: '{count} anunțuri',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expirate',
    pending: 'În așteptare',
    declined: 'Refuzate',
    all: 'Toate',
    noAnnouncements: 'Nu aveți anunțuri în această categorie.',
    noFilterResults: 'Nu am găsit anunțuri pentru filtrele selectate.',
    nameFilterPlaceholder: 'Caută după titlul anunțului',
    clearNameFilter: 'Șterge căutarea',
    clearLocationFilter: 'Șterge locația',
    toggleLocationFilter: 'Arată sau ascunde locațiile',
    showAllFromCounty: 'Arată tot din {county}',
    errorLoading: 'Nu am putut încărca anunțurile. Vă rugăm încercați din nou.',
    postedOn: 'Publicat pe {date}, {time}',
    statusActive: 'Activ',
    statusExpired: 'Expirat',
    statusPending: 'În așteptare',
    statusDeclined: 'Refuzat',
    performance: 'Performanța anunțului',
    oneView: '1 vizualizare',
    viewsCount: '{count} vizualizări',
    oneMessage: '1 mesaj',
    messagesCount: '{count} mesaje',
    openMessages: 'Deschide {count} mesaje',
    openAnnouncement: 'Deschide anunțul {title}',
    moreActions: 'Mai multe acțiuni',
    statusFilterLabel: 'Filtrează după status',
    expiresOn: 'Expiră pe {date}',
    expiresIn: 'în {days}',
    expiresToday: 'Expiră azi',
    expiresTomorrow: 'Expiră mâine',
    expiredOn: 'Expirat pe {date}',
    activateModalTitle: 'Reactivezi anunțul?',
    deactivateModalTitle: 'Dezactivează anunțul?',
    activateModalMessage: 'Anunțul devine din nou activ imediat sau, dacă verificarea prealabilă este activă, după verificarea respectării regulilor de publicare.',
    deactivateModalMessage: 'Sunteți sigur că doriți să dezactivați acest anunț?',
    deleteModalTitle: 'Șterge anunțul?',
    deleteModalMessage: 'Sunteți sigur că doriți să ștergeți acest anunț? Această acțiune este ireversibilă.',
    activateSuccess: 'Reactivarea a fost înregistrată.',
    deactivateSuccess: 'Anunțul a fost dezactivat cu succes',
    deleteSuccess: 'Anunțul a fost șters cu succes',
    statusChangeError: 'Nu am putut schimba statusul anunțului. Vă rugăm încercați din nou.',
    deleteError: 'Nu am putut șterge anunțul. Vă rugăm încercați din nou.',
  },
  settings: {
    title: 'Setări',
    eyebrow: 'Preferințe cont',
    subtitle: 'Gestionează tipul contului și notificările pe care vrei să le primești.',
    accountTypeTitle: 'Tipul contului',
    accountTypeDescription: 'Alege forma în care publici și interacționezi pe roade.ro.',
    accountTypeNotSelected: 'Neselectat',
    accountTypeEmptyTitle: 'Nu ai ales încă tipul contului',
    accountTypeEmptyDescription: 'Poți explora roade.ro fără această alegere. Selectează un tip de cont aici sau când publici primul anunț.',
    accountTypeSelectionRequired: 'Selectează tipul contului înainte de salvare.',
    accountTypeNotice: 'Tipul și datele profesionale sunt afișate public pentru transparență. Confirmă din nou declarația la fiecare modificare.',
    accountTypeSave: 'Salvează datele contului',
    accountTypeSaving: 'Se salvează...',
    accountTypeSaveSuccess: 'Datele contului au fost actualizate.',
    accountTypeSaveError: 'Nu am putut actualiza datele contului. Verifică toate câmpurile și încearcă din nou.',
    notificationsTitle: 'Notificări',
    notificationsDescription: 'Activează doar mesajele care sunt relevante pentru tine. Modificările se salvează automat.',
    activeSummary: '{active} din {total} active',
    marketingEmails: 'Emailuri de marketing',
    marketingEmailsDescription: 'Primește oferte speciale, promoții și noutăți despre produse',
    announcementActivated: 'Anunț activat',
    announcementActivatedDescription: 'Primește notificări când anunțurile tale sunt activate',
    announcementExpired: 'Anunț expirat',
    announcementExpiredDescription: 'Primește notificări când anunțurile tale expiră',
    chatNotifications: 'Notificări chat',
    chatNotificationsDescription: 'Primește notificări când ai mesaje noi de la utilizatori',
    cookiePreferencesTitle: 'Cookie-uri și statistici',
    cookiePreferencesDescription: 'Alege dacă permiți Google Analytics pentru statistici agregate despre utilizarea site-ului.',
    loading: 'Se încarcă preferințele tale...',
  },
  messages: {
    title: 'Mesaje ({count})',
    conversations: 'Conversații',
    moreOptions: 'Mai multe opțiuni',
    backToConversations: 'Înapoi la conversații',
    backToConversation: 'Înapoi la conversație',
    previousImage: 'Imaginea anterioară',
    nextImage: 'Imaginea următoare',
    productDetails: 'Descriere',
    expiredAnnouncement: 'Expirat',
    expiredAnnouncementNotice: 'Acest anunț a expirat. Conversația rămâne disponibilă.',
    blockedAnnouncement: 'Blocat',
    blockedAnnouncementNotice: 'Acest anunț este blocat deoarece contul proprietarului este suspendat. Conversația rămâne disponibilă.',
    messagingBlockedNotice: 'Mesajele sunt dezactivate deoarece unul dintre participanți are contul blocat. Conversația rămâne disponibilă.',
    messagingBlockedPlaceholder: 'Mesajele sunt dezactivate',
    searchPlaceholder: 'Caută după anunț sau utilizator',
    clearSearch: 'Șterge căutarea',
    roleFilterLabel: 'Filtrează conversațiile după rol',
    allRoles: 'Toate',
    sellingRole: 'Vând',
    buyingRole: 'Cumpăr',
    noSearchResultsTitle: 'Nicio conversație găsită',
    noSearchResultsDescription: 'Modifică termenul de căutare sau filtrele selectate.',
    resetFilters: 'Resetează',
    loading: 'Se încarcă mesajele...',
    loadingConversations: 'Se încarcă conversațiile...',
    loadingConversation: 'Se încarcă conversația...',
    loadingMoreConversations: 'Se încarcă mai multe conversații...',
    noMessagesTitle: 'Nu există conversații încă',
    noMessagesDescription: 'Conversațiile despre anunțuri vor apărea aici.',
    selectConversationTitle: 'Selectează o conversație',
    selectConversationDescription: 'Alege o conversație pentru a vedea mesajele.',
    productPlaceholderTitle: 'Detalii anunț',
    productPlaceholderDescription: 'Anunțul asociat conversației va fi afișat aici.',
    openListing: 'Vezi anunțul complet',
    productImages: 'Imaginile anunțului',
    openImage: 'Mărește imaginea {current} din {total}',
    factLocation: 'Localitate',
    factPublished: 'Publicat',
    messageSent: 'Trimis',
    messageSeen: 'Văzut',
    unread: 'necitit',
    emptyConversationTitle: 'Conversație fără mesaje',
    emptyConversationDescription: 'Mesajele din această conversație vor apărea aici.',
    loadingMore: 'Se încarcă mai multe mesaje...',
    messagePlaceholder: 'Mesajul tău...',
    addOrder: 'Adaugă o comandă',
    orderOwnerOnly: 'Doar proprietarul anunțului poate adăuga o comandă din această conversație.',
    orderSaleOnly: 'Comenzile pot fi adăugate doar pentru anunțurile de vânzare.',
    orderProductLoading: 'Așteaptă încărcarea anunțului înainte de a adăuga o comandă.',
    orderProductUnavailable: 'Anunțul conversației nu este disponibil pentru adăugarea unei comenzi.',
    orderListUnavailable: 'Comenzile pot fi adăugate de proprietar doar pentru anunțurile de vânzare.',
    orderPreparationError: 'Nu am putut pregăti comanda. Încearcă din nou.',
    errorLoading: 'Nu am putut încărca mesajele. Vă rugăm încercați din nou.',
    errorSending: 'Nu s-a putut trimite mesajul. Încercați din nou.',
  },
  userDetails: {
    localProducer: 'Producător local',
    activeAnnouncements: '{count} anunțuri active',
    freshFromProducer: 'Direct de la producător',
    announcementsSubtitle: 'Descoperă produsele disponibile și cele mai noi oferte ale producătorului.',
    greeting: 'Salut, sunt {name}',
    companyName: 'Nume firmă',
    about: 'Despre mine',
    contact: 'Contact',
    showPhone: 'Arată',
    hidePhone: 'Ascunde',
    phoneUnavailable: 'Număr indisponibil',
    share: 'Distribuie',
    shareLinkCopied: 'Linkul profilului a fost copiat.',
    shareError: 'Nu am putut distribui profilul. Încearcă din nou.',
    announcements: 'Anunțurile lui {name}',
    loading: 'Se încarcă profilul...',
    loadingAnnouncements: 'Se încarcă anunțurile...',
    emptySaleTitle: 'Momentan nu sunt produse de vânzare',
    emptySaleDescription: 'Acest utilizator nu are anunțuri de vânzare active. Poți reveni mai târziu.',
    emptyWantedTitle: 'Momentan nu sunt cereri de cumpărare',
    emptyWantedDescription: 'Acest utilizator nu are cereri de cumpărare active. Poți reveni mai târziu.',
    notFound: 'Utilizatorul nu a fost găsit',
    notFoundDescription: 'Profilul nu mai este disponibil sau adresa accesată nu este corectă.',
    notFoundAction: 'Înapoi la pagina principală',
    errorLoading: 'Nu am putut încărca datele utilizatorului.',
  },
  productCard: {
    postedOn: 'Postat {date} la {time}',
    messages: 'Mesaje ({count})',
    noImage: 'Fără imagine',
    sellType: 'Vând',
    buyType: 'Caut',
    noReviews: 'Fără recenzii',
    oneReview: '{count} recenzie',
    multipleReviews: '{count} recenzii',
    today: 'Astăzi',
    yesterday: 'Ieri',
    viewsCompact: '{count} vizualizări',
    publishedAt: 'Publicat {date}, {time}',
    updatedAt: 'Actualizat {date}, {time}',
    openProduct: 'Deschide anunțul {title}',
    addFavorite: 'Adaugă la favorite',
    removeFavorite: 'Elimină din favorite',
    ownFavoriteNotAllowed: 'Nu poți adăuga propriul anunț la favorite.',
    favoriteUpdateError: 'Nu am putut actualiza lista de favorite. Încearcă din nou.',
  },
  favorites: {
    title: 'Favorite',
    subtitle: 'Păstrează aproape anunțurile care ți-au atras atenția.',
    savedOne: '1 anunț salvat',
    savedCount: '{count} anunțuri salvate',
    loading: 'Se încarcă anunțurile favorite...',
    error: 'Nu am putut încărca anunțurile favorite.',
    emptyTitle: 'Nu ai anunțuri favorite',
    emptyDescription: 'Apasă pe inimă în dreptul unui anunț pentru a-l salva aici.',
    emptyFilteredTitle: 'Nu ai favorite în această categorie',
    emptyFilteredDescription: 'Alege alt tip de anunț sau salvează unul nou pentru a-l găsi aici.',
    filterLabel: 'Tipul anunțului',
    filterSell: 'Ce se vinde',
    filterBuy: 'Ce se caută',
    viewType: 'Tip afișare',
    listView: 'Afișare listă',
    gridView: 'Afișare grilă',
    previousPage: 'Pagina anterioară',
    nextPage: 'Pagina următoare',
  },
  orders: {
    eyebrow: 'Gestionare vânzări',
    title: 'Comenzi',
    subtitle: 'Organizează comenzile pe locații și anunțuri pentru livrare.',
    add: 'Adaugă o comandă',
    edit: 'Modifică comanda',
    allStatuses: 'Toate stările',
    customerFilter: 'Numele clientului',
    customerFilterPlaceholder: 'Caută după numele clientului',
    statusFilter: 'Stare comandă',
    locationFilter: 'Localitate principală',
    deliveryPointFilter: 'Punct de livrare (opțional)',
    allLocations: 'Toate locațiile',
    allDeliveryPoints: 'Toate punctele de livrare',
    selectMainLocationFirst: 'Selectează mai întâi localitatea',
    dateFrom: 'Comenzi de la',
    dateTo: 'Comenzi până la',
    intervalLabel: 'Interval comenzi',
    intervalHint: 'Alege perioada pentru care vrei să vezi și să gestionezi comenzile.',
    filters: 'Filtre',
    filtersTitle: 'Filtre comenzi',
    filtersHint: 'Restrânge rezultatele după client, stare și punct de livrare.',
    closeFilters: 'Închide filtrele',
    activeFilters: 'Filtre active: {count}',
    applyInterval: 'Aplică',
    applyFilters: 'Aplică filtrele',
    resetFilters: 'Resetează',
    clearDateFrom: 'Șterge data de început',
    clearDateTo: 'Șterge data de sfârșit',
    intervalRequired: 'Selectează data și ora de început și de sfârșit.',
    selectInterval: 'Apasă Aplică pentru a încărca comenzile din intervalul selectat.',
    invalidInterval: 'Data de început trebuie să fie înaintea datei de sfârșit.',
    pending: 'În așteptare',
    delivered: 'Livrată',
    cancelled: 'Anulată',
    totalOrders: 'Comenzi',
    oneOrder: '1 comandă',
    orderCount: '{count} comenzi',
    expected: 'De încasat',
    deliveredAmount: 'Valoare livrată',
    cancelledAmount: 'Valoare anulată',
    productTotal: 'Total anunț',
    locationTotal: 'Total locație',
    customer: 'Client',
    contact: 'Contact',
    quantity: 'Cantitate',
    unit: 'Unitate',
    total: 'Total',
    orderDate: 'Data comenzii',
    deliveryDate: 'Data livrării',
    remarks: 'Observații',
    actions: 'Acțiuni',
    markDelivered: 'Marchează livrată',
    restorePending: 'Mută în așteptare',
    reactivateOrder: 'Reactivează comanda',
    cancelOrder: 'Anulează comanda',
    cancelDialogTitle: 'Anulează comanda?',
    cancelDialogConfirm: 'Anulează comanda',
    deleteOrder: 'Șterge definitiv',
    deleteDialogTitle: 'Șterge comanda?',
    deleteDialogConfirm: 'Șterge comanda',
    empty: 'Nu există comenzi pentru filtrele selectate.',
    loading: 'Se încarcă comenzile...',
    loadError: 'Nu am putut încărca comenzile.',
    optionsLoadError: 'Nu am putut încărca anunțurile și locațiile comenzilor.',
    saveSuccess: 'Comanda a fost salvată.',
    saveError: 'Nu am putut salva comanda.',
    statusSuccess: 'Starea comenzii a fost actualizată.',
    deleteSuccess: 'Comanda a fost ștearsă.',
    actionError: 'Nu am putut actualiza comanda.',
    deleteConfirm: 'Comanda va fi ștearsă definitiv și nu va mai apărea în raport. Continui?',
    cancelConfirm: 'Comanda anulată va rămâne în raport. Continui?',
    exportStarted: 'Descărcarea fișierului {format} a început.',
    exportError: 'Nu am putut exporta comenzile.',
    exportOrders: 'Exportă comenzile',
    form: {
      product: 'Anunț',
      chooseProduct: 'Alege anunțul',
      productNotActive: 'nu mai este activ',
      noActiveProducts: 'Nu ai anunțuri de vânzare active. Comenzile se pot înregistra doar pentru anunțurile tale de vânzare active.',
      deliveryLocation: 'Locația de livrare',
      locationPlaceholder: 'Caută localitatea de livrare',
      deliveryPoint: 'Punct de livrare',
      chooseDeliveryPoint: 'Alege punctul de livrare',
      newDeliveryPoint: 'Adaugă o locație nouă de livrare',
      createDeliveryPointTitle: 'Adaugă un punct de livrare',
      deliveryPointName: 'Numele punctului',
      deliveryPointNamePlaceholder: 'Ex: Vivo sau Grigorescu',
      deliveryAddressDetails: 'Adresă sau detalii (opțional)',
      deliveryAddressPlaceholder: 'Ex: intrarea principală, lângă parcare',
      addDeliveryPoint: 'Adaugă punctul',
      savingDeliveryPoint: 'Se adaugă...',
      deliveryPointCreated: 'Punctul de livrare a fost adăugat și selectat.',
      deliveryPointCreateError: 'Nu am putut adăuga punctul de livrare.',
      customerName: 'Numele clientului',
      customerPhone: 'Telefon (opțional)',
      quantity: 'Cantitate',
      unit: 'Unitate',
      unitPrice: 'Preț unitar',
      orderDate: 'Data comenzii',
      deliveryDate: 'Data livrării (opțional)',
      clearOrderDate: 'Șterge data comenzii',
      clearDeliveryDate: 'Șterge data livrării',
      remarks: 'Observații (opțional)',
      remarksPlaceholder: 'Detalii pentru livrare, interval orar sau alte mențiuni',
      calculatedTotal: 'Total calculat',
      saving: 'Se salvează...',
      requiredError: 'Completează câmpurile obligatorii.',
      fieldRequired: 'Acest câmp este obligatoriu.',
      invalidQuantity: 'Cantitatea trebuie să fie mai mare decât 0.',
      invalidUnitPrice: 'Prețul trebuie să fie 0 sau mai mare.',
      deliveryPointRequiredError: 'Completează numele punctului de livrare.',
      invalidDateRange: 'Data livrării nu poate fi înaintea datei comenzii.',
    },
  },
  orderStatistics: {
    eyebrow: 'Performanța afacerii tale',
    title: 'Statistici comenzi',
    subtitle: 'Urmărește evoluția comenzilor și încasărilor tale într-un tablou de bord simplu și clar.',
    activeRevenue: 'Valoare comenzi active',
    periodLabel: 'Perioada analizată',
    last30Days: '30 zile',
    last90Days: '90 zile',
    lastYear: '1 an',
    summaryLabel: 'Rezumatul comenzilor',
    totalOrders: 'Total comenzi',
    deliveredOrders: 'Comenzi livrate',
    averageOrder: 'Valoare medie',
    perOrder: 'pentru fiecare comandă',
    vsPreviousPeriod: 'față de perioada anterioară',
    newActivity: 'activitate nouă în această perioadă',
    noChange: 'la fel ca în perioada anterioară',
    completionRate: 'Rată de finalizare',
    cancellationRate: 'Rată de anulare',
    pendingOrders: 'Comenzi în așteptare',
    revenueTrend: 'Evoluția încasărilor',
    revenueTrendHint: 'Valoarea comenzilor active comparată cu valoarea deja livrată.',
    expectedRevenue: 'Comenzi active',
    deliveredRevenue: 'Încasări livrate',
    orderStatus: 'Starea comenzilor',
    orderStatusHint: 'Distribuția comenzilor din perioada selectată.',
    pending: 'În așteptare',
    delivered: 'Livrate',
    cancelled: 'Anulate',
    performance: 'Indicatori de performanță',
    performanceHint: 'O privire rapidă asupra eficienței comenzilor tale.',
    topProducts: 'Anunțurile cu cele mai bune rezultate',
    topProductsHint: 'Clasament după valoarea comenzilor active.',
    orderCount: '{count} comenzi',
    unknownProduct: 'Anunț indisponibil',
    noProducts: 'Nu există încă date despre anunțuri în această perioadă.',
    empty: 'Nu există comenzi în perioada selectată.',
    loading: 'Se calculează statisticile...',
    loadError: 'Nu am putut încărca statisticile',
    loadErrorHint: 'Verifică conexiunea și încearcă din nou.',
    retry: 'Încearcă din nou',
  },
  orderReport: {
    eyebrow: 'Analiză vânzări',
    title: 'Raport comenzi',
    subtitle: 'Analizează comenzile, livrările, anulările și sumele estimate.',
    overviewTitle: 'Imagine clară',
    overviewLabel: 'Comenzi și încasări',
    from: 'Data de început',
    to: 'Data de sfârșit',
    intervalLabel: 'Interval raport',
    intervalHint: 'Selectează perioada pe care vrei să o analizezi.',
    clearFrom: 'Șterge data de început',
    clearTo: 'Șterge data de sfârșit',
    statusFilter: 'Stare comandă',
    allStatuses: 'Toate stările',
    granularity: 'Grupare în timp',
    dateField: 'Perioadă calculată după',
    orderDate: 'Data comenzii',
    deliveryDate: 'Data livrării',
    byDay: 'Pe zi',
    byWeek: 'Pe săptămână',
    byMonth: 'Pe lună',
    breakdown: 'Detaliere',
    total: 'Total general',
    byLocation: 'Pe locație',
    byProduct: 'Pe anunț',
    byLocationProduct: 'Pe locație și anunț',
    allLocations: 'Toate locațiile',
    mainLocation: 'Localitate principală',
    deliveryPoint: 'Punct de livrare (opțional)',
    allDeliveryPoints: 'Toate punctele de livrare',
    selectMainLocationFirst: 'Selectează mai întâi localitatea',
    allProducts: 'Toate anunțurile',
    filters: 'Filtre',
    filtersTitle: 'Filtre raport',
    filtersHint: 'Compară rezultatele după stare, locație, anunț și tipul perioadei.',
    closeFilters: 'Închide filtrele',
    activeFilters: 'Filtre active: {count}',
    applyFilters: 'Aplică filtrele',
    resetFilters: 'Resetează',
    generate: 'Generează raportul',
    selectInterval: 'Selectează intervalul și apasă Generează raportul.',
    exportReport: 'Exportă raportul',
    period: 'Perioadă',
    location: 'Locație',
    product: 'Anunț',
    orders: 'Comenzi',
    pending: 'În așteptare',
    delivered: 'Livrate',
    cancelled: 'Anulate',
    quantity: 'Cantitate',
    unit: 'Unitate',
    expected: 'De încasat',
    deliveredAmount: 'Valoare livrată',
    cancelledAmount: 'Valoare anulată',
    visualization: 'Vizualizare grafică',
    chartValues: 'Suma totală, comandă livrată și comandă anulată',
    totalAmountMetric: 'Suma totală',
    deliveredOrderMetric: 'Comandă livrată',
    cancelledOrderMetric: 'Comandă anulată',
    metric: 'Valoare afișată',
    chartType: 'Tip grafic',
    barChart: 'Grafic cu bare',
    pieChart: 'Grafic circular',
    lineChart: 'Grafic liniar',
    expectedMetric: 'Suma de încasat',
    ordersMetric: 'Număr de comenzi',
    deliveredMetric: 'Suma livrată',
    cancelledMetric: 'Suma anulată',
    empty: 'Nu există comenzi în perioada și filtrele selectate.',
    loading: 'Se generează raportul...',
    loadError: 'Nu am putut genera raportul.',
    exportStarted: 'Descărcarea fișierului {format} a început.',
    exportError: 'Nu am putut exporta raportul.',
    invalidInterval: 'Data de început trebuie să fie înaintea datei de sfârșit.',
  },
  adminCard: {
    messages: 'Mesaje ({count})',
    noImage: 'Fără imagine',
    activate: 'Activează',
    deactivate: 'Dezactivează',
    complaints: 'Reclamații ({count})',
  },
  contact: {
    title: 'Contactează-ne',
    subtitle: 'Ai întrebări sau sugestii? Ne-ar plăcea să auzim de la tine!',
    emailNote: 'Ne poți scrie și direct la',
    emailAddress: 'contact@roade.ro',
    phoneNote: 'sau ne poți suna la',
    phoneNumber: '0774 547 296',
    phoneHref: 'tel:+40774547296',
    nameLabel: 'Nume complet',
    namePlaceholder: 'Introdu numele tău',
    emailLabel: 'Adresă de email',
    emailPlaceholder: 'exemplu@email.com',
    phoneLabel: 'Telefon (Opțional)',
    phonePlaceholder: '0771 23 32 01',
    subjectLabel: 'Subiect',
    subjectPlaceholder: 'Despre ce vrei să discutăm?',
    messageLabel: 'Mesaj',
    messagePlaceholder: 'Scrie mesajul tău aici...',
    submitButton: 'Trimite mesaj',
    submitting: 'Se trimite...',
    successMessage: 'Mesajul tău a fost trimis cu succes! Îți vom răspunde în curând.',
    errorMessage: 'A apărut o eroare. Te rugăm să încerci din nou.',
    rateLimited: 'Ai trimis prea multe mesaje într-un interval scurt. Te rugăm să încerci din nou mai târziu.',
    requiredField: 'Acest câmp este obligatoriu',
    invalidEmail: 'Adresa de email nu este validă',
  },
  footer: {
    copyright: 'Copyright © 2026 roade.ro. Toate drepturile rezervate.',
    description: 'Locul în care producătorii locali și cumpărătorii se găsesc mai ușor.',
    operator: 'Platformă operată de EMARKET DIGITAL VENTURES S.R.L. · CUI 55676396 · Reg. Com. J2026057030009',
    navigationLabel: 'Navigare în subsolul paginii',
    consumerProtection: 'Protecția consumatorilor',
    company: 'Companie',
    about: 'Despre noi',
    blog: 'Blog',
    contact: 'Contactează-ne',
    legal: 'Legal',
    termsAndConditions: 'Termeni și Condiții',
    privacyPolicy: 'Politica de Confidențialitate',
    cookiesPolicy: 'Politica de cookie-uri',
    reportIllegalContent: 'Raportează conținut ilegal',
    transport: 'Transport',
    transportDialogTitle: 'Transportul produselor',
    transportDialogDescription: 'roade.ro nu oferă și nu intermediază servicii de transport. Organizarea și costurile transportului sunt stabilite direct între utilizatori.',
    transportDialogPolicy: 'Pentru informații complete despre responsabilitățile privind transportul, consultă Termenii și Condițiile.',
    transportDialogClose: 'Închide',
    transportDialogTerms: 'Vezi Termenii și Condițiile',
    explore: 'Explorează',
    howItWorks: 'Cum funcționează?',
    help: 'Ajutor',
    faqs: 'Întrebări Frecvente',
  },
  illegalContentNotice: {
    title: 'Notificare privind conținut ilegal',
    description: 'Folosește acest formular pentru a semnala conținut despre care consideri, în mod motivat, că este ilegal. Pentru spam sau probleme obișnuite folosește opțiunea Raportează din pagină.',
    contentUrl: 'Adresa exactă a conținutului',
    explanation: 'De ce consideri conținutul ilegal',
    explanationPlaceholder: 'Descrie clar faptele și, dacă este posibil, temeiul legal aplicabil.',
    identityException: 'Conținutul privește una dintre infracțiunile sexuale împotriva minorilor pentru care legea permite omiterea identității.',
    name: 'Nume',
    email: 'Email',
    goodFaith: 'Confirm, cu bună-credință, că informațiile din această notificare sunt corecte și complete.',
    identityRequired: 'Numele și adresa de email sunt obligatorii dacă nu se aplică excepția legală privind identitatea.',
    explanationTooShort: 'Explicația trebuie să conțină cel puțin 20 de caractere.',
    goodFaithRequired: 'Trebuie să confirmi declarația de bună-credință.',
    submit: 'Trimite notificarea',
    submitting: 'Se trimite...',
    submitError: 'Notificarea nu a putut fi trimisă. Verifică datele și încearcă din nou.',
    rateLimited: 'Ai trimis prea multe notificări. Încearcă din nou mai târziu.',
    successTitle: 'Notificarea a fost înregistrată',
    successDescription: 'Păstrează numărul de referință pentru orice comunicare ulterioară.',
  },
  cookieConsent: {
    title: 'Cookie-uri',
    description: 'roade.ro folosește un cookie de sesiune și tehnologii similare strict necesare funcționării platformei. Dacă alegi autentificarea prin Google, Google poate utiliza tehnologiile necesare acestui proces. Analiza nu este activă în această versiune a aplicației. Nu folosim cookie-uri de marketing sau publicitate.',
    acceptAll: 'Am înțeles',
    analyticsDescription: 'roade.ro folosește cookie-uri strict necesare funcționării platformei. Cu acordul tău, folosim și Google Analytics pentru statistici agregate despre utilizarea site-ului (pagini vizitate, căutări, contactarea vânzătorilor, publicarea anunțurilor). Nu folosim cookie-uri de marketing sau publicitate. Dacă alegi autentificarea prin Google, Google poate utiliza tehnologiile necesare acestui proces. Poți schimba oricând alegerea din „Preferințe cookie-uri”.',
    acceptAnalytics: 'Acceptă analiza',
    declineAnalytics: 'Refuză analiza',
    currentChoiceGranted: 'Alegerea curentă: analiza este acceptată.',
    currentChoiceDenied: 'Alegerea curentă: analiza este refuzată.',
    preferences: 'Preferințe cookie-uri',
    customize: 'Personalizează',
    necessaryTitle: 'Strict necesare',
    necessaryDescription: 'Mențin sesiunea de autentificare, securitatea platformei și memorarea alegerii tale privind cookie-urile. Nu pot fi dezactivate.',
    alwaysActive: 'Mereu active',
    analyticsTitle: 'Analiză (Google Analytics)',
    analyticsOptionDescription: 'Cu acordul tău, trimitem către Google date despre paginile vizitate, căutări, contactarea vânzătorilor, publicarea anunțurilor, înregistrări și autentificări, împreună cu identificatori de browser și date tehnice, pentru statistici agregate. Nu trimitem textul căutărilor, nume, adrese de e-mail, numere de telefon sau conținutul mesajelor.',
    allowAnalytics: 'Permite analiza',
    back: 'Înapoi',
    save: 'Salvează preferințele',
    policyLink: 'Detalii complete în',
    policyLinkText: 'Politica privind cookie-urile',
  },
  installApp: {
    title: 'Adaugă roade.ro pe ecranul principal',
    description: 'Creează o scurtătură către roade.ro pentru acces rapid. Nu se instalează o aplicație.',
    install: 'Adaugă',
    iosAction: 'Vezi pașii',
    iosInstructions: 'În Safari, apasă pictograma Distribuie, apoi „Adaugă la ecranul principal”. Se va crea doar o scurtătură către roade.ro.',
    dismiss: 'Închide recomandarea pentru scurtătură',
  },
  administration: {
    title: 'Administrare',
    workspaceEyebrow: 'CENTRU DE CONTROL',
    workspaceDescription: 'Urmărește activitatea platformei și gestionează rapid conținutul care are nevoie de atenție.',
    statisticsTab: 'Statistici',
    productsTab: 'Anunțuri',
    usersTab: 'Utilizatori',
    reportedProductsTab: 'Anunțuri raportate',
    reportedUsersTab: 'Utilizatori Raportați',
    reportedChatsTab: 'Chat-uri Raportate',
    contactMessagesTab: 'Mesaje de contact',
    illegalContentTab: 'Conținut ilegal',
    prohibitedProductsTab: 'Produse nepermise',
    legalDocumentsTab: 'Documente legale',
    serviceNoticesTab: 'Informări prin email',
    configurationTab: 'Configurare',
    configuration: {
      eyebrow: 'SETĂRI OPERAȚIONALE',
      title: 'Configurarea platformei',
        description: 'Controlează aprobarea anunțurilor și emailurile trimise proprietarilor despre starea acestora.',
      approvalTitle: 'Aprobarea anunțurilor',
      approvalDescription: 'Când este activă, anunțurile noi, modificate sau reactivate intră în așteptare pentru verificarea unui administrator.',
      approvalWarning: 'Anunțurile noi vor deveni active imediat. Anunțurile aflate deja în așteptare nu sunt modificate.',
        emailTitle: 'Emailurile despre anunțuri',
        emailDescription: 'Controlează emailurile despre activarea și expirarea anunțurilor. Emailul de respingere, care conține motivele, este trimis întotdeauna.',
        emailWarning: 'Emailurile despre activarea și expirarea anunțurilor nu vor fi trimise. Respingerea anunțurilor, verificarea contului, recuperarea parolei, mesajele și formularul de contact rămân active.',
      enabled: 'Activată',
      disabled: 'Dezactivată',
      unsaved: 'Modificări nesalvate',
      lastUpdated: 'Ultima modificare: {date}',
        environmentDefaults: 'Sunt active valorile implicite ale platformei.',
      save: 'Salvează modificările',
      saving: 'Se salvează...',
      saveSuccess: 'Configurarea platformei a fost actualizată.',
      saveError: 'Nu am putut actualiza configurarea platformei.',
      loading: 'Încărcăm configurarea...',
      loadError: 'Nu am putut încărca configurarea platformei.',
      retry: 'Încearcă din nou',
    },
    statistics: {
      title: 'Imaginea de ansamblu',
      description: 'Date actualizate despre creșterea și starea platformei.',
      overview: 'Prezentare',
      products: 'Anunțuri',
      users: 'Utilizatori',
      periodLabel: 'Perioada graficului',
      last7Days: '7 zile',
      last30Days: '30 zile',
      last90Days: '90 zile',
      lastYear: '12 luni',
      totalProducts: 'Total anunțuri',
      totalUsers: 'Total utilizatori',
      newToday: 'Noi astăzi',
      newThisWeek: 'Noi săptămâna aceasta',
      newThisMonth: 'Noi luna aceasta',
      periodGrowth: 'față de perioada anterioară',
      noPeriodChange: 'Fără schimbare față de perioada anterioară',
      trendTitle: 'Evoluția înscrierilor',
      trendDescription: 'Anunțuri și utilizatori noi în perioada selectată',
      productHealth: 'Starea anunțurilor',
      productMix: 'Tipul anunțurilor',
      userHealth: 'Starea utilizatorilor',
      verification: 'Verificarea emailului',
      active: 'Active',
      pending: 'În așteptare',
      declined: 'Respinse',
      expired: 'Expirate',
      forSale: 'Ce se vinde',
      wanted: 'Ce se caută',
      blocked: 'Blocați',
      verified: 'Verificați',
      unverified: 'Neverificați',
      generatedAt: 'Actualizat la {date}',
      loading: 'Pregătim statisticile...',
      loadError: 'Nu am putut încărca statisticile.',
      retry: 'Încearcă din nou',
      productsLegend: 'Anunțuri noi',
      usersLegend: 'Utilizatori noi',
    },
    legalDocuments: {
      title: 'Documente legale',
      description: 'Creează, verifică și publică versiuni fără a modifica istoricul existent.',
      documentTabs: 'Tipuri de documente legale',
      newVersion: 'Versiune nouă',
      createDraft: 'Creează o ciornă',
      editDraft: 'Editează ciorna',
      immutableHint: 'După publicare, conținutul și versiunea nu mai pot fi modificate.',
      viewMode: 'Mod de afișare',
      edit: 'Editare',
      preview: 'Previzualizare',
      type: 'Tip document',
      version: 'Versiune',
      documentTitle: 'Titlul documentului',
      effectiveAt: 'Intră în vigoare la',
      requiresAcceptance: 'Solicită acceptarea explicită a utilizatorilor',
      termsAcceptanceHint: 'La publicare, utilizatorilor li se va solicita acceptarea explicită a acestei versiuni.',
      changeSummary: 'Rezumatul modificărilor',
      content: 'Conținut Markdown',
      importFile: 'Importă fișier .md sau .txt',
      cancel: 'Anulează',
      close: 'Închide',
      saveDraft: 'Salvează ciorna',
      saving: 'Se salvează...',
      untitled: 'Document fără titlu',
      emptyPreview: 'Adaugă conținut pentru a vedea previzualizarea.',
      acceptanceRequired: 'Necesită acceptare',
      acceptances: 'Acceptări',
      publish: 'Publică',
      schedule: 'Programează',
      returnToDraft: 'Revino la ciornă',
      deleteDraft: 'Șterge ciorna',
      noVersions: 'Nu există versiuni pentru acest document.',
      requiredFields: 'Completează toate câmpurile obligatorii marcate cu roșu.',
      fieldRequired: 'Acest câmp este obligatoriu.',
      invalidField: 'Valoarea introdusă nu este validă.',
      invalidDate: 'Selectează o dată și o oră valide.',
      versionFormat: 'Folosește doar litere, cifre, punct, cratimă sau underscore.',
      versionExistsError: 'Această versiune există deja pentru documentul selectat.',
      termsAcceptanceError: 'Termenii și condițiile trebuie să solicite acceptarea explicită.',
      acceptanceNotSupportedError: 'Acceptarea explicită este disponibilă doar pentru Termeni și condiții.',
      notFoundError: 'Versiunea documentului nu mai există. Reîncarcă lista și încearcă din nou.',
      invalidStatusError: 'Acțiunea nu mai este disponibilă pentru starea actuală a documentului.',
      saveSuccess: 'Ciorna documentului a fost salvată.',
      saveError: 'Nu am putut salva ciorna documentului.',
      loadError: 'Nu am putut încărca documentele legale.',
      publishSuccess: 'Versiunea documentului a fost publicată.',
      scheduleSuccess: 'Versiunea documentului a fost programată.',
      returnSuccess: 'Versiunea programată a revenit la starea de ciornă.',
      deleteSuccess: 'Ciorna a fost ștearsă.',
      actionError: 'Nu am putut finaliza acțiunea pentru document.',
      fileTypeError: 'Poți importa doar fișiere Markdown sau text.',
      fileReadError: 'Nu am putut citi fișierul selectat.',
      publishConfirmTitle: 'Publică versiunea',
      publishConfirmMessage: 'Versiunea {version} va deveni activă la data stabilită și nu va mai putea fi modificată.',
      deleteConfirmTitle: 'Șterge ciorna',
      deleteConfirmMessage: 'Sigur dorești să ștergi definitiv ciorna {version}?',
      confirmPublish: 'Confirmă publicarea',
      confirmDelete: 'Șterge ciorna',
    },
    products: {
      title: 'Anunțuri în așteptare',
      statusPending: 'În așteptare',
      statusActive: 'Active',
      statusExpired: 'Expirate',
      statusDeclined: 'Respinse',
      ownerBlocked: 'Blocat - cont suspendat',
      adminBlocked: 'Blocat de administrator',
      approve: 'Aprobă',
      decline: 'Respinge',
      noProducts: 'Nu există anunțuri în această categorie.',
      errorLoading: 'Nu am putut încărca anunțurile. Vă rugăm încercați din nou.',
      approveSuccess: 'Anunțul a fost aprobat cu succes',
      declineSuccess: 'Anunțul a fost respins cu succes',
      errorUpdating: 'Nu am putut actualiza anunțul. Vă rugăm încercați din nou.',
    },
    users: {
      title: 'Utilizatori',
      search: 'Caută utilizatori...',
      noUsers: 'Nu există utilizatori.',
      errorLoading: 'Nu am putut încărca utilizatorii. Vă rugăm încercați din nou.',
      announcementUsage: 'Anunțuri',
      announcementLimit: 'Limită anunțuri',
      newAnnouncementLimit: 'Limită nouă',
      increaseAnnouncementLimit: 'Mărește limita',
      increasingAnnouncementLimit: 'Se actualizează...',
      announcementLimitHint: 'Introduceți o valoare mai mare decât limita actuală, de maximum 100.000.',
      announcementLimitInvalid: 'Limita nouă trebuie să fie un număr întreg mai mare decât limita actuală.',
      announcementLimitSuccess: 'Limita de anunțuri a fost mărită cu succes.',
      announcementLimitError: 'Nu am putut mări limita de anunțuri. Vă rugăm încercați din nou.',
    },
    reportedChats: {
      reportedBy: 'Raportat de',
      reportedUser: 'Utilizator raportat',
      product: 'Anunț',
      reasons: 'Motive',
      productNameFilter: 'Nume anunț',
      reportedByFilter: 'Utilizator care a raportat',
      reportedUserFilter: 'Utilizator raportat',
      messages: 'mesaje',
      conversationId: 'ID conversație',
      previousReports: 'raportări anterioare pentru utilizator',
      noChats: 'Nu există chat-uri raportate.',
      errorLoading: 'Nu am putut încărca chat-urile raportate. Vă rugăm încercați din nou.',
    },
    contactMessages: {
      messageStatus: 'Starea solicitării',
      deliveryStatus: 'Livrarea emailului',
      allStatuses: 'Toate',
      statusNew: 'Nou',
      statusRead: 'Citit',
      statusResolved: 'Rezolvat',
      deliveryPending: 'În așteptare',
      deliverySent: 'Trimis',
      deliveryFailed: 'Eșuat',
      sentAt: 'Trimis la',
      empty: 'Nu există mesaje de contact.',
      loadError: 'Nu am putut încărca mesajele de contact. Vă rugăm încercați din nou.',
      updateSuccess: 'Starea mesajului a fost actualizată.',
      updateError: 'Nu am putut actualiza mesajul de contact.',
      delete: 'Șterge definitiv',
      deleteConfirmation: 'Sigur doriți să ștergeți definitiv acest mesaj?',
      deleteSuccess: 'Mesajul de contact a fost șters.',
      deleteError: 'Nu am putut șterge mesajul de contact.',
    },
    illegalContent: {
      eyebrow: 'SIGURANȚA PLATFORMEI',
      title: 'Notificări privind conținut ilegal',
      description: 'Analizează notificările formale, documentează decizia și comunică rezultatul persoanei care a trimis notificarea.',
      statusFilter: 'Filtrează după stare',
      allStatuses: 'Toate',
      statusReceived: 'Primite',
      statusUnderReview: 'În analiză',
      statusActionTaken: 'Măsuri luate',
      statusRejected: 'Respinse',
      reporter: 'Persoană care notifică',
      identityOmitted: 'Identitate omisă în baza excepției declarate',
      contentUrl: 'Conținut semnalat',
      explanation: 'Explicație',
      decision: 'Motivarea deciziei',
      markUnderReview: 'Începe analiza',
      markActionTaken: 'Confirmă măsurile',
      markRejected: 'Respinge notificarea',
      decisionRequired: 'Adaugă motivarea înainte de finalizarea notificării.',
      updateSuccess: 'Notificarea a fost actualizată.',
      updateError: 'Notificarea nu a putut fi actualizată.',
      empty: 'Nu există notificări pentru filtrul selectat.',
      loadError: 'Notificările nu au putut fi încărcate.',
      retry: 'Încearcă din nou',
    },
  },
  rejectionModal: {
    title: 'Respinge anunțul',
    selectReasons: 'Alege motivele. Vânzătorul le primește pe email, împreună cu mesajul de mai jos.',
    reasonsLegend: 'Motive',
    confirm: 'Respinge',
    messageLabel: 'Mesaj pentru vânzător',
    messageOptional: '(opțional)',
    messageRequired: '(obligatoriu pentru „Altele”)',
    messagePlaceholder: 'Explică pe scurt ce trebuie corectat. Poți folosi sugestiile de mai jos.',
    messageMissing: 'Scrie mesajul pentru vânzător când alegi „Altele”.',
    suggestionsTitle: 'Sugestii de text',
    suggestionsHint: 'Apasă pe o sugestie pentru a o adăuga în mesaj. O poți modifica apoi.',
    prohibitedSuggestionsTitle: 'Produse nepermise',
    added: 'Adăugat',
    reasons: [
      {
        id: 'prohibited_items',
        label: 'Articole interzise',
        hint: 'Produsul nu poate fi vândut pe roade.ro.',
      },
      {
        id: 'requires_authorisation',
        label: 'Produs care necesită autorizație',
        hint: 'Se poate vinde doar cu autorizație, înregistrare sau notificare.',
        suggestion: 'Vânzarea acestui produs necesită o autorizație, o înregistrare sau o notificare prevăzută de lege. Trimite dovada la contact@roade.ro și vom reanaliza anunțul.',
      },
      {
        id: 'wrong_category',
        label: 'Categorie greșită',
        hint: 'Produsul nu corespunde categoriei alese.',
        suggestion: 'Anunțul a fost publicat într-o categorie care nu corespunde produsului. Alege categoria potrivită și publică din nou anunțul.',
      },
      {
        id: 'misleading_information',
        label: 'Informații înșelătoare',
        hint: 'Titlul, descrierea sau pozele nu corespund produsului.',
        suggestion: 'Titlul, descrierea sau fotografiile nu corespund produsului oferit. Descrie corect produsul și publică din nou anunțul.',
      },
      {
        id: 'incomplete_details',
        label: 'Detalii incomplete',
        hint: 'Lipsesc cantitatea, unitatea sau alte date importante.',
        suggestion: 'Anunțului îi lipsesc informații importante, de exemplu cantitatea disponibilă sau unitatea de măsură. Completează-le și publică din nou anunțul.',
      },
      {
        id: 'unrealistic_price',
        label: 'Preț nerealist',
        hint: 'Prețul este simbolic sau nu pare real.',
        suggestion: 'Prețul nu pare real pentru produsul oferit. Indică prețul la care vinzi efectiv produsul și publică din nou anunțul.',
      },
      {
        id: 'poor_quality_images',
        label: 'Imagini de calitate slabă',
        hint: 'Pozele sunt neclare sau nu arată produsul.',
        suggestion: 'Fotografiile sunt neclare sau nu arată produsul. Adaugă cel puțin o fotografie clară cu produsul oferit și publică din nou anunțul.',
      },
      {
        id: 'inappropriate_content',
        label: 'Conținut inadecvat',
        hint: 'Texte sau imagini nepotrivite pentru platformă.',
        suggestion: 'Anunțul conține texte sau imagini care nu sunt potrivite pentru roade.ro. Elimină-le și publică din nou anunțul.',
      },
      {
        id: 'not_suitable',
        label: 'Produs nepotrivit pentru roade.ro',
        hint: 'Nu este un produs agricol, alimentar sau legat de agricultură.',
        suggestion: 'roade.ro este dedicat produselor agricole, alimentare și celor legate de agricultură. Acest produs nu se încadrează în categoriile platformei.',
      },
      {
        id: 'duplicate_listing',
        label: 'Anunț duplicat',
        hint: 'Există deja un anunț pentru același produs.',
        suggestion: 'Ai deja un anunț pentru același produs. Actualizează anunțul existent în loc să publici unul nou.',
      },
      {
        id: 'other',
        label: 'Altele',
        hint: 'Scrie motivul în mesajul de mai jos.',
      },
    ],
  },
  /**
   * Starting texts for rejections, used by the admin "Produse nepermise" page and the rejection
   * dialog. Drafted from Terms §8 and §14; check each case, they are not legal advice.
   */
  prohibitedProducts: {
    tab: 'Produse nepermise',
    eyebrow: 'GHID DE MODERARE',
    title: 'Produse nepermise',
    description: 'Texte de pornire pentru respingerea anunțurilor. Copiază motivul și adaptează-l dacă e nevoie. Verifică fiecare caz: textele nu înlocuiesc o analiză juridică.',
    kindForbidden: 'Interzis',
    kindProof: 'Necesită dovadă',
    examples: 'Exemple',
    copy: 'Copiază motivul',
    copied: 'Copiat',
    copyError: 'Textul nu a putut fi copiat. Selectează-l și copiază-l manual.',
    items: [
      {
        id: 'home_spirits',
        kind: 'forbidden',
        title: 'Băuturi spirtoase de casă',
        examples: 'țuică, pălincă, rachiu, horincă din producție proprie',
        reason: 'Băuturile spirtoase pot fi vândute doar de producători autorizați pentru produse accizabile. Băuturile distilate în gospodărie nu pot fi vândute pe roade.ro.',
      },
      {
        id: 'alcohol',
        kind: 'proof',
        title: 'Alte băuturi alcoolice',
        examples: 'vin, bere, lichior, vișinată',
        reason: 'Băuturile alcoolice pot fi vândute doar de vânzători care dețin autorizațiile prevăzute de lege. Dacă le ai, trimite dovada la contact@roade.ro și vom reanaliza anunțul.',
      },
      {
        id: 'home_slaughter',
        kind: 'forbidden',
        title: 'Carne din sacrificare în gospodărie',
        examples: 'porc tăiat în curte, cârnați sau slănină „de la porcul nostru”',
        reason: 'Carnea și preparatele din carne pot fi vândute doar dacă provin din unități autorizate sanitar-veterinar. Carnea din animalele sacrificate în gospodărie este destinată consumului propriu.',
      },
      {
        id: 'animal_products',
        kind: 'proof',
        title: 'Produse de origine animală',
        examples: 'brânză, lapte, ouă, miere, pește, preparate din carne',
        reason: 'Pentru acest produs este necesară înregistrarea sau autorizarea sanitar-veterinară (DSVSA). Adaugă numărul în descriere sau trimite-l la contact@roade.ro și vom reanaliza anunțul.',
      },
      {
        id: 'game',
        kind: 'proof',
        title: 'Carne de vânat',
        examples: 'mistreț, căprior, fazan',
        reason: 'Carnea de vânat poate fi vândută doar în condițiile sanitar-veterinare prevăzute de lege. Trimite documentele la contact@roade.ro și vom reanaliza anunțul.',
      },
      {
        id: 'cosmetics',
        kind: 'proof',
        title: 'Cosmetice',
        examples: 'creme, săpunuri, unguente, balsamuri',
        reason: 'Produsele cosmetice pot fi vândute doar după notificarea lor conform Regulamentului (CE) nr. 1223/2009. Trimite dovada notificării la contact@roade.ro și vom reanaliza anunțul.',
      },
      {
        id: 'health_claims',
        kind: 'forbidden',
        title: 'Pretenții de vindecare',
        examples: '„leac pentru…”, „vindecă…”, tincturi prezentate ca tratament',
        reason: 'Anunțurile nu pot prezenta produsele ca tratament sau leac pentru boli. Elimină aceste afirmații și publică din nou anunțul.',
      },
      {
        id: 'plant_protection',
        kind: 'forbidden',
        title: 'Produse de protecție a plantelor',
        examples: 'pesticide, ierbicide, insecticide, fungicide',
        reason: 'Produsele de protecție a plantelor pot fi vândute doar de distribuitori autorizați și nu pot fi vândute prin anunțuri pe roade.ro.',
      },
      {
        id: 'veterinary_medicines',
        kind: 'forbidden',
        title: 'Medicamente de uz veterinar',
        examples: 'antibiotice, vaccinuri, antiparazitare',
        reason: 'Medicamentele de uz veterinar pot fi vândute doar de unități farmaceutice veterinare autorizate și nu pot fi vândute prin anunțuri pe roade.ro.',
      },
    ],
  },
} as const;
